import PropTypes from "prop-types";
import Parser from "html-react-parser";
import DOMPurify from 'dompurify';

const HtmlText = ({ htmlText }) => {
  return Parser(DOMPurify.sanitize(htmlText));
};

HtmlText.propTypes = {
  htmlText: PropTypes.string.isRequired
};

export default HtmlText;
